'use client';

import { Map, Flag } from 'lucide-react';
import type { City } from '@/hooks/useCities';

interface CityCardProps {
  city: City;
  isSelected: boolean;
  onSelect: (city: City) => void;
}

export default function CityCard({ city, isSelected, onSelect }: CityCardProps) {
  const handleMapClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // 阻止事件冒泡，避免触发城市选择
    const url = `/map?a=${city.slug}`;
    window.open(url, '_blank');
  };

  return (
    <div 
      className={`border rounded-lg p-4 hover:shadow-md transition-all cursor-pointer flex flex-col h-full relative ${
        isSelected 
          ? 'bg-sky-50 border-sky-300 shadow-md' 
          : 'bg-white border-slate-200 hover:border-slate-300'
      }`}
      onClick={() => onSelect(city)}
    >
      {/* 城市名称和国家 */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div 
            className="w-4 h-4 rounded-full"
            style={{ backgroundColor: city.color }}
          />
          <h3 className="font-semibold text-slate-900">{city.name}</h3>
        </div>
        <div className="flex items-center gap-1 text-xs text-slate-500">
          <Flag className="h-3 w-3" />
          <span>{city.country}</span>
        </div>
      </div>

      {/* 多语言名称 */}
      <div className="text-sm text-slate-600 mb-3 flex-1">
        <div className="flex flex-wrap gap-1">
          <span className="bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded text-xs">{city.name_zh}</span>
          {city.name_fr && (
            <span className="bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded text-xs">{city.name_fr}</span>
          )}
          {city.name_es && (
            <span className="bg-red-50 text-red-700 px-1.5 py-0.5 rounded text-xs">{city.name_es}</span>
          )}
          {city.name_ar && (
            <span className="bg-green-50 text-green-700 px-1.5 py-0.5 rounded text-xs">{city.name_ar}</span>
          )}
          {city.name_ru && (
            <span className="bg-orange-50 text-orange-700 px-1.5 py-0.5 rounded text-xs">{city.name_ru}</span>
          )}
          {city.name_pt && (
            <span className="bg-yellow-50 text-yellow-700 px-1.5 py-0.5 rounded text-xs">{city.name_pt}</span>
          )}
        </div>
      </div>

      {/* 操作按钮 */}
      <div className="flex gap-2 mt-3">
        <button
          onClick={handleMapClick}
          className="w-full bg-sky-700 text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-sky-800 transition-colors flex items-center justify-center gap-1"
        >
          <Map className="h-3 w-3" />
          Explore On Map
        </button>
      </div>

    </div>
  );
}
